import React from 'react';
import PropTypes from 'prop-types';

import './LiveRegion.css';

function LiveRegion({ children, className }) {
  return (
    <div
      aria-live='polite'
      aria-atomic='true'
      className={`LiveRegion${className ? ` ${className}` : ''}`}>
      {children}
    </div>
  );
}

LiveRegion.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

LiveRegion.defaultProps = {
  children: null,
  className: null,
};

export default LiveRegion;
